import sliceCreator from '../../index.js';
import {GET_ORDER} from '../../../constants/index.js';
const _deleteOrderAction = sliceCreator('GET_ORDER',GET_ORDER, 'delete');

const { asyncAction: deleteOrderAction, reducer, clearData: cleardeleteOrderAction } = _deleteOrderAction;

export default reducer;

export {
    deleteOrderAction,
    cleardeleteOrderAction
}


